import React, { useState,useEffect } from "react";
import amaxLogo from "../../images/amaxLogo.png";
import { Link,useNavigate } from "react-router-dom";
import { useCoachLogin } from "./useCoachLogin";


export const CoachLogin = () => {

  const [email,setEmail] = useState('');
  const [password,setPassword] = useState('');
  const {coachLogin, error, isLoading} = useCoachLogin();
  
  const handleSubmit = async (e) => {

      e.preventDefault();
      await coachLogin(email,password);
  }

  return (
    <div className="p-[20px] bg-black h-dvh overflow-hidden">
      <div className="w-full max-w-2xl mx-auto h-full flex flex-col justify-between items-center gap-[160px] overflow-y-auto">
        <Link to="/" className="size-[96px] lg:size-[166px]">
            <img src={amaxLogo} alt="logo" className="object-contain" />
        </Link>
        <div className="w-full flex flex-col gap-8">
          <div className="flex flex-col gap-[15px]">
            <p className="text-white text-[26px] leading-[108%] font-normal">
              Sign in <br />
              <span className="font-bold text-[40px] leading-[95%]">
                COACH.
              </span>
            </p>

               {/* Display Error Message */}
               {error && (
                    <p className="text-red-500 text-sm mt-2">
                      {error}
                    </p>
                )}

                   {/* Display Loading Indicator */}
              {isLoading && (
                <p className="text-yellow-500 text-sm mt-2">
                  Processing request please wait...
                </p>
              )} 

            <form action="" className="flex flex-col gap-[15px]">
              <input
                type="email"
                className="border border-white rounded-[50px] bg-transparent text-white text-lg !leading-none p-[16px] font-normal placeholder:text-[#5d5d5d]"
                placeholder="Email*"
                value={email}
                onChange={(element) => setEmail(element.target.value)}
              />
              <input
                type="password"
                className="border border-white rounded-[50px] bg-transparent text-white text-lg !leading-none p-[16px] font-normal placeholder:text-[#5d5d5d]"
                placeholder="Password*"
                value={password}
                onChange={(element) => setPassword(element.target.value)}
              />
            </form>
           
              <button  onClick={handleSubmit} className="text-base font-semibold w-full bg-white transition-all duration-300 rounded-[75px] border border-white flex justify-center items-center px-2 py-[18px] hover:text-white hover:bg-transparent">
                SIGN IN
              </button>
           
            <Link
              to="/coach/forgot-password"
              className="text-white hover:text-[#5d5d5d] transition-all duration-300 text-sm font-normal text-end inline-block w-fit ml-auto"
            >
              Forgot password?
            </Link>
          </div>
          <div className="flex flex-col gap-[15px]">
            <Link
              to="/coach/register/step1"
              className="text-white hover:text-[#5d5d5d] transition-all duration-300 text-sm font-normal text-start inline-block w-fit"
            >
              Not a Member?
            </Link>
            <Link to="/coach/register/step1">
              <button className="text-base text-white font-semibold w-full transition-all duration-300 rounded-[75px] hover:bg-white hover:text-black border border-white flex justify-center items-center px-2 py-[18px]">
                JOIN US
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
